<!-- 定增资金-->
<template>
  <div class="zdcaptial-wrap">
    <vue-loading 
      v-if="isshowloading"
      style="margin-top: 60px;"
      type="bars" 
      color="#d9544e" 
      :size="{ width: '50px', height: '50px' }"
    ></vue-loading>
    <div class="tabs">
      <div
        v-for="(item, i) in tab.text"
        :ref="'dz' + i"
        :class="['tab', i === tab.index  && 'active']"
        :key=i
        @click="tab.index = i;changetab()"
      >{{item}}</div>
      <div :ltip="szmessage" class="tips"></div>
    </div>

    <div class="chart-1">
      <ChartTpl
        :enableResize='true'
        :elementId='"zdcaptialCircle"'
        :width='"100%"'
        :height='"120px"'
        :option='circleOption'
        :originData='circleData'
      ></ChartTpl></div>
    <div class="chart debug">
      <!-- {{tab.text[tab.index]}}的图 -->
      <ChartTpl
        v-show="tab.index === 0"
        ref="dzLine0"
        :firstTooltip='true'
        :elementId='"dzLine0"'
        :enableResize='true'
        :width='"100%"'
        :height='"248px"'
        :option='line0Option'
        :originData='line0Data'
        ></ChartTpl>
      
      <template v-if="alreadyLoad1">
        <ChartTpl
          v-show="tab.index === 1"
          ref="dzLine1"
          :elementId='"dzLine1"'
          :firstTooltip='true'
          :enableResize='true'
          :width='"100%"'
          :height='"248px"'
          :option='line1Option'
          :originData='line1Data'
        ></ChartTpl>
      </template>

    </div>

  </div>
</template>

<script>
import ChartTpl from '@/components/ChartTpl.vue';
import { VueLoading } from 'vue-loading-template';

export default {
  name: "DZCapital",
  components: {
    ChartTpl,
    VueLoading
  },
  props: {
    elementId: {
      type: String,
      default: "hello"
    },
    fixedIncreaseMoney:{
      type: Object,
      default: function () {
        return {}
      }
    },
    fixedIncreaseMoneySeries:{
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      tab: {
        index: 0,
        text: ["定增资金", "配股资金"]
      },
      chart: {},
      szmessage: '定增资金：非公开发行，即向特定投资者发行',
      circleOption: {},
      circleData:[],

      line0Option: {},
      line0Data:[],
      line1Option: {},
      line1Data:[],

      reductionMoneySeries: [],
      allotmentMoneySeries: [],
      alreadyLoad1: false,
      isshowloading: false
    };
  },
  watch: {
    allotmentMoneySeries: {
      handler(newvalue, oldvalue){
        this.initLine2();
      }
    },
    fixedIncreaseMoneySeries: {
      handler(newvalue, oldvalue){
        this.init();
      }
    },
    'tab.index':{
      handler(newvalue, oldvalue){
        let alreadyLoadStr = 'alreadyLoad'+newvalue;
        let getDataStr = 'getData'+newvalue;

        if (newvalue !== 0) {
          if(!this[alreadyLoadStr]) this[getDataStr]();
          this[alreadyLoadStr] = true;
        }

        setTimeout(()=>{
          this.$refs['dzLine'+newvalue].resize();
        })
      }
    }
  },
  mounted() {
    this.report()
    LTip.width = 200;
    LTip.pos = 'right' ;
    LTip.theme = 'black';
    LTip.reBind();

    if(!this.fixedIncreaseMoneySeries.length) return;
    this.init();
  },
  methods:{
    report () {
      let ta = [{ id: 'pcweb_hgdata_dzzj' }, { id: 'pcweb_hgdata_pgzj' }]
      for (let i = 0; i < this.tab.text.length; i++) {
        let elm = this.$refs['dz'+i][0]
        TA.logElementClick(elm, ta[i])
      }
    },
    changetab() {
      switch(this.tab.index){
        case 0:
          this.szmessage = '定增资金：非公开发行，即向特定投资者发行'
          break;
        case 1:
          this.szmessage = '配股资金：向原股票股东按其持股比例、以低于市价的某一特定价格配售一定数量新发行股票的融资行为'
          break;
        default:
          this.szmessage = '定增资金：非公开发行，即向特定投资者发行'
      }
    },
    getData1(){
      this.isshowloading = true;
      this.$api.blockAPI
        .getAllotmentMoneySeries()
        .then(res => {
          if (res.code === 0) {
            this.allotmentMoneySeries = res.data.allotmentMoneySeries;
            this.isshowloading = false;
          }
        })
        .catch(e => {});
    },
    initCircle(){

      let { fixedIncreaseMoney, allotmentMoney } = this.fixedIncreaseMoney;
      this.circleOption = this.$chartConfigs.doubleCircle();
      this.circleOption.data[0] = {
        originData: [{
          min: 0,
          max: 1,
          title: '定增资金',
          values: [
            {
              value: fixedIncreaseMoney.percentile,
              show: fixedIncreaseMoney.value 
            }
          ]
        },{
          min: 0,
          max: 1,
          title: '配股资金',
          values: [
            {
              value: allotmentMoney.percentile,
              show: allotmentMoney.value 
            }
          ]
        }]
      };

      this.circleData = this.circleOption.data;
    },
    
    initLine2(){
      this.line1Option = this.$chartConfigs.line1({
        name:'配股资金', 
        dataKey:'allotment_money'
      });
      this.line1Data = [{
        originData: this.allotmentMoneySeries
      }]
    },
    initLine(){
      this.line0Option = this.$chartConfigs.line1({
        name:'定增资金', 
        dataKey:'fixed_increase_money'
      });
      this.line0Data = [{
        originData: this.fixedIncreaseMoneySeries
      }]
    },
    init(){
      this.initLine();
      this.initCircle();
    }
  }
};
</script>

<style scoped>
.zdcaptial-wrap {
  font-size: 14px;
  display: flex;
  flex-direction: column;
}
.tabs {
  display: flex;
  margin-bottom: 10px;
  flex: 0 0 auto;
  align-items: center;
  /* font-weight: 700; */
}
.tab {
  border: 1px solid #3b3c41;
  padding: 2px 12px;
  margin-left: -1px;
  cursor: pointer;
}
.tab.active {
  background: #3b3c41;
  color: #fff;
  cursor: default;
}

.chart-1 {
  height: 130px;
  flex: 0 0 auto;
  margin-bottom: 1px;
}

.chart {
  flex: 1 1 auto;
}
.tips {
  position: relative;
  background: url('//s.thsi.cn/js/zijinquanxi/assets/pc/tips.png') no-repeat;
  vertical-align: middle;
  margin-left:10px;
  width:24px;
  height: 16px;
}
.vue-loading {
  position: absolute;
  top: 50%;
  left: 40%;
  z-index: 9999;
}
</style>
